
<section class="bg-[#f6f7f9] min-h-screen lg:min-h-[50vh] flex items-center py-10 lg:py-0 overflow-hidden p-6">
  <swiper-container slides-per-view="1" speed="1000" loop="true" autoplay-delay="3000"
    autoplay-disable-on-interaction="false" class="w-full">

    <swiper-slide>
      <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div class="space-y-6 order-2 md:order-1 text-center md:text-left">
          <p class="text-[#2800a0] font-semibold tracking-wide uppercase">Smart School Management System</p>
          <h1 class="text-4xl md:text-5xl font-bold text-[#002670] leading-[1.2]">
            আপনার স্কুলকে করুন ডিজিটাল, আমাদের স্মার্ট সফটওয়্যারের মাধ্যমে
          </h1>
          <p class="text-gray-600 text-lg">সহজেই স্টুডেন্ট ভর্তি, অনলাইন পেমেন্ট এবং স্কুলের যাবতীয় কার্যক্রম পরিচালনা
            করুন।</p>
          <a href="https://www.youtube.com/watch?v=rCCVGi_h3nA"
            class="bg-gradient-primary  text-white px-8 py-3 rounded-md hover:bg-blue-800 transition-all shadow-md">সফটওয়্যার
            ডেমো দেখুন</a>
        </div>
        <div class="flex justify-center relative order-1 md:order-2 scale-95 md:scale-100 py-10">
          <img ngSrc="Ss-4.png" width="800" height="500" priority alt="Software Preview" class="relative z-0 rounded-lg">
          <div
            class="z-10 absolute w-[200px] md:w-[230px] bg-white bottom-10 -right-4 md:-right-10 p-4 rounded-md shadow-xl animate-float">
            <div class="flex bg-white mb-2">
              <img ngSrc="slider-card-1.png" width="32" height="32" class="w-8 h-8 rounded-full border border-white">
              <img ngSrc="slider-card-2.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-3.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-4.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
            </div>
            <p class="text-sm font-medium text-gray-700">ইতিমধ্যেই <span class="text-[#2800a0] font-bold">৫০০+
                স্কুল</span> ব্যবহার করছে</p>
          </div>
          <div class="z-10 absolute -left-10 md:-left-20 bottom-20"><img ngSrc="slider-shape-6.png" width="64" height="64"
              class="animate-pulse"></div>
          <div
            class="absolute bottom-5 -left-5 md:-left-10 z-20 bg-green-50/80 p-3 w-32 md:w-36 flex flex-col justify-center items-center shadow-lg rounded-md animate-float-slow">
            <img ngSrc="shape-04.png" width="32" height="32" class="w-8 mb-1">
            <p class="text-[10px] md:text-xs font-bold text-center text-[#002670]">জনপ্রিয় স্কুল সফটওয়্যার</p>
          </div>
          <div class="absolute top-40 left-0 animate-bounce-slow opacity-70"><img ngSrc="shape-01.png" width="64" height="64">
          </div>
          <div class="z-10 absolute top-20 right-0"><img ngSrc="shape-02.png" width="64" height="64" class="animate-spin-slow opacity-70">
          </div>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div class="space-y-6 order-2 md:order-1 text-center md:text-left">
          <p class="text-[#2800a0] font-semibold tracking-wide uppercase">Smart School Management System</p>
          <h1 class="text-4xl md:text-5xl font-bold text-[#002670] leading-[1.2]">
            আপনার স্কুলকে করুন ডিজিটাল, আমাদের স্মার্ট সফটওয়্যারের মাধ্যমে
          </h1>
          <p class="text-gray-600 text-lg">সহজেই স্টুডেন্ট ভর্তি, অনলাইন পেমেন্ট এবং স্কুলের যাবতীয় কার্যক্রম পরিচালনা
            করুন।</p>
          <a href="https://www.youtube.com/watch?v=rCCVGi_h3nA"
            class="bg-gradient-primary  text-white px-8 py-3 rounded-md hover:bg-blue-800 transition-all shadow-md">সফটওয়্যার
            ডেমো দেখুন</a>
        </div>
        <div class="flex justify-center relative order-1 md:order-2 scale-95 md:scale-100 py-10">
          <img ngSrc="Ss.png" width="800" height="500" priority alt="Software Preview" class="relative z-0 rounded-lg">
          <div
            class="z-10 absolute w-[200px] md:w-[230px] bg-white bottom-10 -right-4 md:-right-10 p-4 rounded-md shadow-xl animate-float">
            <div class="flex bg-white mb-2">
              <img ngSrc="slider-card-1.png" width="32" height="32" class="w-8 h-8 rounded-full border border-white">
              <img ngSrc="slider-card-2.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-3.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-4.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
            </div>
            <p class="text-sm font-medium text-gray-700">ইতিমধ্যেই <span class="text-[#2800a0] font-bold">৫০০+
                স্কুল</span> ব্যবহার করছে</p>
          </div>
          <div class="z-10 absolute -left-10 md:-left-20 bottom-20"><img ngSrc="slider-shape-6.png" width="64" height="64"
              class="animate-pulse"></div>
          <div
            class="absolute bottom-5 -left-5 md:-left-10 z-20 bg-green-50/80 p-3 w-32 md:w-36 flex flex-col justify-center items-center shadow-lg rounded-md animate-float-slow">
            <img ngSrc="shape-04.png" width="32" height="32" class="w-8 mb-1">
            <p class="text-[10px] md:text-xs font-bold text-center text-[#002670]">জনপ্রিয় স্কুল সফটওয়্যার</p>
          </div>
          <div class="absolute top-40 left-0 animate-bounce-slow opacity-70"><img ngSrc="shape-01.png" width="64" height="64">
          </div>
          <div class="z-10 absolute top-20 right-0"><img ngSrc="shape-02.png" width="64" height="64" class="animate-spin-slow opacity-70">
          </div>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide>
      <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div class="space-y-6 order-2 md:order-1 text-center md:text-left">
          <p class="text-[#2800a0] font-semibold tracking-wide uppercase">Smart School Management System</p>
          <h1 class="text-4xl md:text-5xl font-bold text-[#002670] leading-[1.2]">
            আপনার স্কুলকে করুন ডিজিটাল, আমাদের স্মার্ট সফটওয়্যারের মাধ্যমে
          </h1>
          <p class="text-gray-600 text-lg">সহজেই স্টুডেন্ট ভর্তি, অনলাইন পেমেন্ট এবং স্কুলের যাবতীয় কার্যক্রম পরিচালনা
            করুন।</p>
          <a href="https://www.youtube.com/watch?v=rCCVGi_h3nA"
            class="bg-gradient-primary text-white px-8 py-3 rounded-md hover:bg-blue-800 transition-all shadow-md">সফটওয়্যার
            ডেমো দেখুন</a>
        </div>
        <div class="flex justify-center relative order-1 md:order-2 scale-95 md:scale-100 py-10">
          <img ngSrc="Ss-2.png" width="800" height="500" priority alt="Software Preview" class="relative z-0 rounded-lg">
          <div
            class="z-10 absolute w-[200px] md:w-[230px] bg-white bottom-10 -right-4 md:-right-10 p-4 rounded-md shadow-xl animate-float">
            <div class="flex bg-white mb-2">
              <img ngSrc="slider-card-1.png" width="32" height="32" class="w-8 h-8 rounded-full border border-white">
              <img ngSrc="slider-card-2.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-3.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-4.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
            </div>
            <p class="text-sm font-medium text-gray-700">ইতিমধ্যেই <span class="text-[#2800a0] font-bold">৫০০+
                স্কুল</span> ব্যবহার করছে</p>
          </div>
          <div class="z-10 absolute -left-10 md:-left-20 bottom-20"><img ngSrc="slider-shape-6.png" width="64" height="64"
              class="animate-pulse"></div>
          <div
            class="absolute bottom-5 -left-5 md:-left-10 z-20 bg-green-50/80 p-3 w-32 md:w-36 flex flex-col justify-center items-center shadow-lg rounded-md animate-float-slow">
            <img ngSrc="shape-04.png" width="32" height="32" class="w-8 mb-1">
            <p class="text-[10px] md:text-xs font-bold text-center text-[#002670]">জনপ্রিয় স্কুল সফটওয়্যার</p>
          </div>
          <div class="absolute top-40 left-0 animate-bounce-slow opacity-70"><img ngSrc="shape-01.png" width="64" height="64">
          </div>
          <div class="z-10 absolute top-20 right-0"><img ngSrc="shape-02.png" width="64" height="64" class="animate-spin-slow opacity-70">
          </div>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div class="space-y-6 order-2 md:order-1 text-center md:text-left">
          <p class="text-[#2800a0] font-semibold tracking-wide uppercase">Smart School Management System</p>
          <h1 class="text-4xl md:text-5xl font-bold text-[#002670] leading-[1.2]">
            আপনার স্কুলকে করুন ডিজিটাল, আমাদের স্মার্ট সফটওয়্যারের মাধ্যমে
          </h1>
          <p class="text-gray-600 text-lg">সহজেই স্টুডেন্ট ভর্তি, অনলাইন পেমেন্ট এবং স্কুলের যাবতীয় কার্যক্রম পরিচালনা
            করুন।</p>
          <a href="https://www.youtube.com/watch?v=rCCVGi_h3nA"
            class="bg-gradient-primary  text-white px-8 py-3 rounded-md hover:bg-blue-800 transition-all shadow-md">সফটওয়্যার
            ডেমো দেখুন</a>
        </div>
        <div class="flex justify-center relative order-1 md:order-2 scale-95 md:scale-100 py-10">
          <img ngSrc="Sss.png" width="800" height="500" priority alt="Software Preview" class="relative z-0 rounded-lg">
          <div
            class="z-10 absolute w-[200px] md:w-[230px] bg-white bottom-10 -right-4 md:-right-10 p-4 rounded-md shadow-xl animate-float">
            <div class="flex bg-white mb-2">
              <img ngSrc="slider-card-1.png" width="32" height="32" class="w-8 h-8 rounded-full border border-white">
              <img ngSrc="slider-card-2.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-3.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
              <img ngSrc="slider-card-4.png" width="32" height="32" class="w-8 h-8 rounded-full -ml-2 border border-white">
            </div>
            <p class="text-sm font-medium text-gray-700">ইতিমধ্যেই <span class="text-[#2800a0] font-bold">৫০০+
                স্কুল</span> ব্যবহার করছে</p>
          </div>
          <div class="z-10 absolute -left-10 md:-left-20 bottom-20"><img ngSrc="slider-shape-6.png" width="64" height="64"
              class="animate-pulse"></div>
          <div
            class="absolute bottom-5 -left-5 md:-left-10 z-20 bg-green-50/80 p-3 w-32 md:w-36 flex flex-col justify-center items-center shadow-lg rounded-md animate-float-slow">
            <img ngSrc="shape-04.png" width="32" height="32" class="w-8 mb-1">
            <p class="text-[10px] md:text-xs font-bold text-center text-[#002670]">জনপ্রিয় স্কুল সফটওয়্যার</p>
          </div>
          <div class="absolute top-40 left-0 animate-bounce-slow opacity-70"><img ngSrc="shape-01.png" width="64" height="64">
          </div>
          <div class="z-10 absolute top-20 right-0"><img ngSrc="shape-02.png" width="64" height="64" class="animate-spin-slow opacity-70">
          </div>
        </div>
      </div>
    </swiper-slide>

  </swiper-container>
</section>